import React, { useEffect } from 'react';

import { Translate } from 'react-localize-redux';

import { logger } from '../../../core/services/loggerService';
import { reloadPage } from '../../../utils/domUtils';
import { ErrorFaceIcon } from '../../icons/ErrorFaceIcon';
import { Fallback } from '../Fallback';

type Props = { isNoAppDesignScheme?: boolean; logIdentifier?: string };

export const ErrorFallback = (props: Props): JSX.Element => {
  const { isNoAppDesignScheme = false, logIdentifier = '' } = props;

  useEffect(() => {
    if (logIdentifier) {
      logger.warn(`${logIdentifier} Error Fallback`);
    }
  }, []);

  return (
    <Fallback
      action={{
        onClick: reloadPage,
        text: <Translate id="ErrorFallback_RefreshPage" />,
      }}
      dataFd="error-fallback"
      description={<Translate id="ErrorFallback_Description" />}
      icon={<ErrorFaceIcon data-fd="error-face-icon" />}
      isNoAppDesignScheme={isNoAppDesignScheme}
      title={<Translate id="ErrorFallback_Title" />}
      variant="page"
    />
  );
};
